import React from 'react'
import OpportunitySectionSkeleton from './OpportunitySectionSkeleton'

interface RoadmapContentSkeletonProps {
  capacity: number
}

const RoadmapContentSkeleton = ({ capacity }: RoadmapContentSkeletonProps) => {
  return (
    <div className="px-8 pb-8 w-full">
      <OpportunitySectionSkeleton title="Start Now" color="#FF4A8E" cardCount={capacity} />

      <OpportunitySectionSkeleton title="Next Up" color="#FFC921" cardCount={capacity} />

      <OpportunitySectionSkeleton title="Start Soon" color="#34AED7" cardCount={capacity} />

      <OpportunitySectionSkeleton title="Start Later" color="#62718D" cardCount={capacity} borderBottom={false} />
    </div>
  )
}

export default RoadmapContentSkeleton
